import {isVisible} from "./bitmask";
import {HandleSelectBrowser} from "./browser";

export const onHandleUrlBtn = (url: string,isVisible: boolean, browser: string, isCopied:boolean,onError?:()=>void,onSuccess?:()=>void) => {
    if(isVisible){
        if (!isCopied) {
            if(onError){
                onError()
            }
            return
        }
    }

    if(onSuccess){
        onSuccess()
    }

    HandleSelectBrowser(url, browser)
}

export const copyToClipboard = async (value: string,onError?:(e:string)=>void,onSuccess?:()=>void,onFinal?:()=>void) => {
    if (typeof window !== 'undefined' && navigator.clipboard) {
        try {
            await navigator.clipboard.writeText(value)
            if(onSuccess){
                onSuccess()
            }
        } catch (err) {
            console.error('클립보드 복사 중 오류가 발생했습니다:', err)
            if(onError){
                onError("클립보드 복사 중 오류가 발생했습니다")
            }
        } finally {
            if(onFinal){
                onFinal()
            }
        }
    } else {
        console.warn('이 환경에서는 클립보드 기능을 사용할 수 없습니다.')
    }
}